module.exports = __webpack_public_path__ + "static/img/broederlow-lachlan.58cabb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broederlow-lachlan.jpg
// module id = Wo6/
// module chunks = 0